import { Container, Sprite, Text, type Texture } from 'pixi.js';

// One skill cell: icon with a name plate under it, centered on the icon at
// (0,0). Proportions are relative to iconSize so the slot looks identical at
// any scale (enemy card grid, skills tab row, ...).
const PLATE_OFFSET_Y = 0.655; // icon center -> plate center
const LABEL_FONT = 0.166;
// fine-tune of the label text's vertical centering on the plate art
// (negative = up). Re-check visually whenever proportions change.
const LABEL_TEXT_NUDGE_Y = 0;

export type SkillSlotData = {
  icon?: Texture;
  label: string;
};

export type SkillSlotOptions = {
  data: SkillSlotData;
  labelBg: Texture;
  iconSize: number;
  fontFamily?: string;
  textResolution: number;
};

export class SkillSlot extends Container {
  constructor(opts: SkillSlotOptions) {
    super();
    const { data, labelBg, iconSize, fontFamily, textResolution } = opts;

    // the plate matches the icon's rendered width exactly
    let plateW = iconSize;
    if (data.icon) {
      const icon = new Sprite(data.icon);
      const iconScale = iconSize / Math.max(data.icon.width, data.icon.height);
      icon.anchor.set(0.5);
      icon.scale.set(iconScale);
      this.addChild(icon);
      plateW = data.icon.width * iconScale;
    }

    const plate = new Sprite(labelBg);
    plate.anchor.set(0.5);
    plate.scale.set(plateW / labelBg.width);
    plate.position.set(0, PLATE_OFFSET_Y * iconSize);
    this.addChild(plate);

    const label = new Text({
      text: data.label,
      style: {
        fontFamily,
        fontSize: LABEL_FONT * iconSize,
        fontWeight: 'bold',
        fill: 0x4a3826,
      },
      resolution: textResolution,
    });
    label.anchor.set(0.5);
    label.position.set(plate.x, plate.y + LABEL_TEXT_NUDGE_Y * iconSize);
    this.addChild(label);
  }
}
